import { WrappedInput } from '@quick/components/Forms';

import { useAppTranslation } from '@/app/i18n/client';

const Assistants = ({
  assistants,
  onAssistantChange,
}: {
  assistants: number | undefined;
  onAssistantChange: (val: string) => void;
}) => {
  const { t } = useAppTranslation(['common', 'demand']);

  return (
    <WrappedInput
      label={t('demand:stepper.assistance')}
      type="number"
      isOnModal
      innerClassName="no-arrows"
      className="bg-background-light relative h-10 w-20 rounded border-gray-200 text-center
        font-semibold text-gray-800 focus:border-blue-600 focus-visible:outline-0
        dark:border-gray-600 dark:bg-gray-600 dark:text-white"
      value={assistants ?? 0}
      onChange={(e) => {
        let value = Number.parseInt(e.target.value);
        if (value > 10) value = 10;
        if (value < 0) value = 0;
        if (Number.isNaN(value)) value = 0;
        onAssistantChange(value.toString());
      }}
      min="0"
      max="10"
    />
  );
};

export { Assistants };
